import*as t from"dompurify";const i=(i,o=String)=>t.sanitize(o(i||""),{USE_PROFILES:{html:!0}});export{i as sanitizeHtml};